
const system = [
  {
    "phaseKey": "setting",
    "phaseTitle": "系统配置",
    "phaseDescription": "线上系统配置",
    "phaseTasks": [
      {
        "name": "providerModels",
        "shortName": "models",
        "label": "模型配置",
        "description": "三方模型列表。",
        "description_en": "Third-Party models。",
        "value": "setting.models"
      },
      {
        "name": "accessTokens",
        "shortName": "tokens",
        "label": "鉴权设置",
        "description": "第三方token映射",
        "description_en": "Third-Party tokens",
        "value": "setting.tokens"
      }
    ]
  },
  {
    "phaseKey": "localSetting",
    "phaseTitle": "本地配置",
    "phaseDescription": "本地系统配置",
    "phaseTasks": [
      {
        "name": "AIKeys",
        "shortName": "aikeys",
        "label": "AIKeys",
        "description": "本地自配置AI Key",
         "description_en": "Local AI Key Config",
        "value": "localSetting.aikeys"
      },
      {
        "name": "PersonalKey",
        "shortName": "personKeys",
        "label": "个人秘钥",
        "description": "个人加密秘钥",
         "description_en": "Local Key Config",
        "value": "localSetting.personKeys"
      }
    ]
  }
];


// 咨询顾问 (Guidance)
const guidance_gemini = [
  {
    "phaseKey": "guidance",
    "phaseTitle": "作为专家顾问进行交互式引导",
    "phaseDescription": "作为一名专家顾问，你的任务是通过多轮、有状态的对话，主动引导我厘清模糊需求、完成复杂决策或操作流程。",
    "phaseTasks": [
      {
        "name": "aiContextInitiation",
        "shortName": "initiation",
        "label": "明确意图与目标",
        "description": "首先，主动向我提问，以了解我的基本情况、核心诉求以及最终想达成的目标，为我们的对话建立初始上下文。",
        "description_en": "First, proactively ask me questions to understand my basic situation, core needs, and ultimate goals, establishing the initial context for our conversation.",
        "value": "guidance.initiation"
      },
      {
        "name": "aiMultiTurnDialogue",
        "shortName": "dialogue",
        "label": "深入挖掘与约束",
        "description": "接下来，通过一系列连续、深入的问题，挖掘我可能未明确表达的深层需求、个人偏好和所有相关的约束条件。",
        "description_en": "Next, through a series of continuous, in-depth questions, uncover my potential unexpressed deep needs, personal preferences, and all relevant constraints.",
        "value": "guidance.dialogue"
      },
      {
        "name": "aiStructuredGuidance",
        "shortName": "structured",
        "label": "生成结构化方案",
        "description": "根据我们讨论的全部内容，将我模糊的需求转化为一个清晰、可执行的步骤列表或行动计划，并引导我逐一完成。",
        "description_en": "Based on all the content we discussed, transform my vague needs into a clear, actionable step-by-step list or action plan, and guide me through completing them one by one.",
        "value": "guidance.structured"
      }
    ]
  }
];

// gemini3.0
const guidance = [
  {
    "phaseKey": "guidance",
    // 优化点：强调“深度决策辅助”和“全链路”，提升专业感
    // "phaseTitle": "专家顾问式引导与深度决策辅助", 
    "phaseTitle": "专家引导与深度辅助",
    
    // 优化点：
    // 1. 引入“结构化思维模型”概念。
    // 2. 强调从“模糊”到“精准”的转化。
    // 3. 明确产出不仅仅是回答，而是“解决方案”。
    "phaseDescription": "模拟资深行业顾问的思维模式，不直接提供表层答案，而是通过结构化问诊和深度交互，协助你从混沌中提炼核心问题。利用专业框架拆解复杂场景，权衡利弊，最终推导出兼具战略高度与落地性的解决方案。",

    "phaseTasks": [
      {
        "name": "aiContextInitiation",
        "shortName": "initiation",
        // 优化：从简单的“明确意图”升级为“诊断”
        "label": "背景诊断与目标对齐",
        //"description": "作为顾问的第一步，我将通过关键性提问建立上下文，不仅了解你的显性需求，更致力于诊断现状背后的核心痛点与最终愿景。",
        //"description_en": "As a first step in consulting, I will establish context through key questions, aiming not only to understand your explicit needs but also to diagnose the core pain points and ultimate vision behind the current situation.",
        //"description": "请提供你当前面临的初始问题、背景材料或模糊的想法。作为你的咨询顾问，我不会急于给出结论，而是会基于这些信息，通过关键性提问来建立上下文，协助你诊断现状背后的核心痛点，并对齐最终的战略愿景。",
        //"description_en": "Please submit your initial questions, background materials, or vague ideas. As your consultant, I will not rush to conclusions. Instead, I will use this information to establish context through key inquiries, helping you diagnose the core pain points behind the status quo and align on the ultimate strategic vision.",
        
        // 精简后的中文：直接、清晰，兼顾指令与引导
        "description": "请提交你的初始问题或背景材料。作为顾问，我将先通过关键提问建立上下文，帮你诊断现状背后的核心痛点，并对齐最终愿景。",
        
        // 精简后的英文：Direct and clear
        "description_en": "Please submit your initial questions or background materials. As your consultant, I will first establish context through key inquiries to diagnose core pain points and align on the ultimate vision.",
        
        "value": "guidance.initiation"
      },
      {
        "name": "aiMultiTurnDialogue",
        "shortName": "dialogue",
        // 优化：强调“思维框架”和“边界条件”
        "label": "深度探询与框架构建",
        "description": "利用思维框架（如5W2H、SWOT等）进行多轮深度探询，挖掘潜在的限制条件、风险因素及偏好，将模糊的想法具象化。",
        "description_en": "Using thinking frameworks (like 5W2H, SWOT, etc.), I will conduct deep multi-turn inquiries to uncover potential constraints, risk factors, and preferences, concretizing vague ideas.",
        "value": "guidance.dialogue"
      },
      {
        "name": "aiStructuredGuidance",
        "shortName": "structured",
        // 优化：强调“可行性”和“行动”
        "label": "生成结构化行动方案",
        "description": "基于前序诊断与分析，将共识转化为结构化的交付物——包含清晰的决策建议、分步执行路径及关键成功要素的完整方案。",
        "description_en": "Based on the preceding diagnosis and analysis, transform the consensus into structured deliverables—a complete plan containing clear decision recommendations, step-by-step execution paths, and key success factors.",
        "value": "guidance.structured"
      }
    ]
  }
];


// 研究员 (Researcher)
const researcher = [
  {
    "phaseKey": "research",
    "phaseTitle": "作为领域研究员进行研究与分析",
    "phaseDescription": "作为一名资深研究员，你的任务是根据指定主题，从海量信息中提取、加工、并整合成有价值的、可行动的洞察。",
    "phaseTasks": [
      {
        "name": "aiInformationCollection",
        "shortName": "collection",
        "label": "收集与筛选信息",
        "description": "根据我给出的研究主题，请自动检索、抓取并初步筛选相关的文本、数据、文献等一手和二手信息。",
        "description_en": "Based on the research topic I provide, automatically retrieve, capture, and preliminarily filter relevant primary and secondary information such as text, data, and literature.",
        "value": "research.collection"
      },
      {
        "name": "aiAnalysisSynthesis",
        "shortName": "analysis",
        "label": "分析与梳理信息",
        "description": "请对收集到的信息进行深度加工，包括但不限于：摘要总结、分类、聚类、情感分析和关键数据提取。",
        "description_en": "Perform in-depth processing on the collected information, including but not limited to: summary, classification, clustering, sentiment analysis, and key data extraction.",
        "value": "research.analysis"
      },
      {
        "name": "aiInsightSynthesis",
        "shortName": "synthesis",
        "label": "提炼洞察与结论",
        "description": "基于分析结果，请识别出核心模式、发展趋势和关键关联，并生成一份结构化的结论、研究报告或决策建议。",
        "description_en": "Based on the analysis results, identify core patterns, development trends, and key relationships, and generate structured conclusions, research reports, or decision recommendations.",
        "value": "research.synthesis"
      }
    ]
  }
];

// 创作者 (Producer)
const producer = [
  {
    "phaseKey": "creation",
    "phaseTitle": "作为创意伙伴进行构思与生成",
    "phaseDescription": "作为一名创意伙伴，你的任务是帮助我从一个想法开始，产生全新的、原创性的内容。",
    "phaseTasks": [
      {
        "name": "aiBrainstorming",
        "shortName": "ideation",
        "label": "头脑风暴",
        "description": "基于我提供的初始指令或种子概念，请生成多个不同的创意方向、主题、标题或初步概念草案供我选择。",
        "description_en": "Based on the initial instructions or seed concept I provide, generate multiple different creative directions, themes, titles, or preliminary concept drafts for me to choose from.",
        "value": "creation.ideation"
      },
      {
        "name": "aiContentGeneration",
        "shortName": "generation",
        "label": "内容生成",
        "description": "根据我选定的方向和提供的详细要求，请生成一份完整的内容初稿（例如：文章、代码、脚本、图像描述等）。",
        "description_en": "According to the direction I selected and the detailed requirements provided, generate a complete first draft of the content (e.g., article, code, script, image description, etc.).",
        "value": "creation.generation"
      },
      {
        "name": "aiVariationExpansion",
        "shortName": "variation",
        "label": "变体与拓展",
        "description": "请对已生成的内容进行多样化处理，例如：用不同的风格、语气、格式重写，或者进行扩写、缩写、翻译。",
        "description_en": "Perform diversification processing on the generated content, for example: rewriting in different styles, tones, formats, or performing expansion, abbreviation, translation.",
        "value": "creation.variation"
      }
    ]
  }
];

// 质检员 (Validator)
const validator = [
  {
    "phaseKey": "validation",
    "phaseTitle": "作为质检专家进行优化与校验",
    "phaseDescription": "作为一名严谨的质检专家，你的任务是对已有的内容进行批判性检查、修正和提升，确保其质量、准确性和合规性。",
    "phaseTasks": [
      {
        "name": "aiValidationCheck",
        "shortName": "check",
        "label": "审核与校验",
        "description": "请自动检查我提供的内容，识别其中可能存在的语法、逻辑、事实性错误，以及风格不一致、代码缺陷或不合规等问题。",
        "description_en": "Automatically check the content I provide, identifying potential grammatical, logical, factual errors, as well as style inconsistencies, code defects, or non-compliance issues.",
        "value": "validation.check"
      },
      {
        "name": "aiFeedbackAnalysis",
        "shortName": "feedback",
        "label": "分析反馈",
        "description": "请分析来自用户或评审的反馈，总结其中主要的正面和负面评价、情绪倾向，并提炼出具体的修改要点。",
        "description_en": "Analyze feedback from users or reviewers, summarize the main positive and negative comments, sentiment tendencies, and extract specific revision points.",
        "value": "validation.feedback"
      },
      {
        "name": "aiOptimizationIteration",
        "shortName": "optimization",
        "label": "迭代优化",
        "description": "根据校验结果和反馈分析，请直接生成一个优化后的版本，或提供具体的修改建议和多种替代方案。",
        "description_en": "Based on the validation results and feedback analysis, directly generate an optimized version, or provide specific revision suggestions and multiple alternative solutions.",
        "value": "validation.optimization"
      }
    ]
  }
];

// 学习导师 (Tutor)
const tutor = [
  {
    "phaseKey": "learning_planning",
    "phaseTitle": "学习规划与定位",
    "phaseDescription": "作为一名个人学习导师，你的任务是帮助我评估现状、明确目标，并为我制定一个高度个性化的学习路径。",
    "phaseTasks": [
      {
        "name": "aiLearningAssessment",
        "shortName": "assessment",
        "label": "评估与定位",
        "description": "通过对话或测试，评估我当前的知识水平、学习风格和兴趣点，明确我的学习起点。",
        "description_en": "Through dialogue or testing, assess my current knowledge level, learning style, and interests to clarify my starting point for learning.",
        "value": "planning.assessment"
      },
      {
        "name": "aiPathGeneration",
        "shortName": "pathing",
        "label": "生成学习路径",
        "description": "根据评估结果和学习目标，为我生成一份分阶段的学习计划，包含关键概念、推荐资源和建议的学习节奏。",
        "description_en": "Based on the assessment results and learning goals, generate a phased learning plan for me, including key concepts, recommended resources, and suggested learning pace.",
        "value": "planning.pathing"
      }
    ]
  },
  {
    "phaseKey": "knowledge_acquisition",
    "phaseTitle": "核心知识讲解",
    "phaseDescription": "作为导师，你的任务是用最适合我的方式讲解核心知识点，提供多样化的材料和案例，帮助我建立初步理解。",
    "phaseTasks": [
      {
        "name": "aiKnowledgeProvision",
        "shortName": "provision",
        "label": "多角度解读知识",
        "description": "针对学习路径中的每个核心概念，请提供多种解释（如：使用类比、比喻、或严格定义），并推荐高质量的学习材料。",
        "description_en": "For each core concept in the learning path, provide multiple explanations (e.g., using analogies, metaphors, or strict definitions) and recommend high-quality learning materials.",
        "value": "acquisition.provision"
      },
      {
        "name": "aiConceptVisualization",
        "shortName": "visualization",
        "label": "可视化抽象概念",
        "description": "请将抽象的、难以理解的概念，生成为图像、思维导图、流程图或代码示例，以帮助我直观理解。",
        "description_en": "Transform abstract, difficult-to-understand concepts into images, mind maps, flowcharts, or code examples to help me understand intuitively.",
        "value": "acquisition.visualization"
      }
    ]
  },
  {
    "phaseKey": "knowledge_systemization",
    "phaseTitle": "知识内化与系统化",
    "phaseDescription": "作为知识内化与系统化专家，你的任务是引导我对新知识进行深加工，将其与已知知识关联，构建结构化的个人知识体系。",
    "phaseTasks": [
      {
        "name": "aiGuidedSummarization",
        "shortName": "summarization",
        "label": "引导式总结",
        "description": "通过提问或提供模板，引导我用自己的话对所学内容进行总结、做笔记或提出问题，以加深理解。",
        "description_en": "Through questioning or providing templates, guide me to summarize the learned content in my own words, take notes, or ask questions to deepen understanding.",
        "value": "systemization.summarization"
      },
      {
        "name": "aiKnowledgeMapping",
        "shortName": "mapping",
        "label": "构建知识图谱",
        "description": "请帮助我将新学的概念与已有的知识点连接起来，形成一张可视化的知识网络，清晰地展示它们之间的关联。",
        "description_en": "Help me connect newly learned concepts with existing knowledge points to form a visual knowledge network that clearly shows the relationships between them.",
        "value": "systemization.mapping"
      }
    ]
  },
  {
    "phaseKey": "application_feedback",
    "phaseTitle": "实践与反馈",
    "phaseDescription": "作为实践与反馈专家，你的任务是为我创建实践环境，检验我的掌握程度，并提供即时、精准的反馈，纠正我的理解偏差。",
    "phaseTasks": [
      {
        "name": "aiScenarioGeneration",
        "shortName": "scenario",
        "label": "生成实践场景",
        "description": "请为我生成相关的练习题、模拟项目任务、案例分析或角色扮演情景，让我在实践中应用所学知识。",
        "description_en": "Generate relevant practice questions, simulated project tasks, case studies, or role-playing scenarios for me to apply the learned knowledge in practice.",
        "value": "application.scenario"
      },
      {
        "name": "aiFeedbackCorrection",
        "shortName": "feedback",
        "label": "评审与纠偏",
        "description": "请评审我提交的答案或解决方案，精准地指出其中的错误、逻辑漏洞，并提供详细的解析和改进建议。",
        "description_en": "Review the answers or solutions I submit, accurately point out errors and logical flaws, and provide detailed analysis and improvement suggestions.",
        "value": "application.feedback"
      }
    ]
  },
  {
    "phaseKey": "reinforcement_internalization",
    "phaseTitle": "巩固与内化",
    "phaseDescription": "作为知识巩固与内化专家，你的任务是通过科学的复习方法和费曼学习法，帮助我对抗遗忘，将知识彻底内化，达到精通水平。",
    "phaseTasks": [
      {
        "name": "aiSpacedRepetition",
        "shortName": "repetition",
        "label": "间隔复习",
        "description": "根据艾宾浩斯遗忘曲线，在合适的时机主动向我推送之前学过的概念或问题，以强化我的长期记忆。",
        "description_en": "Based on the Ebbinghaus forgetting curve, proactively push previously learned concepts or questions to me at appropriate times to strengthen my long-term memory.",
        "value": "reinforcement.repetition"
      },
      {
        "name": "aiFeynmanSimulation",
        "shortName": "teaching",
        "label": "模拟教学",
        "description": "请扮演一个对该领域一无所知的新手，让我向你讲解某个概念。你需要不断提出问题和挑战，直到我能用最简单、清晰的语言讲明白为止。",
        "description_en": "Please role-play as a novice who knows nothing about this field, and let me explain a concept to you. You need to continuously ask questions and challenge until I can explain it clearly in the simplest language.",
        "value": "reinforcement.teaching"
      }
    ]
  }
];

// 小说创作专用工作流
const novel = [
  {
    "phaseKey": "world",
    "phaseTitle": "世界观构建",
    "phaseDescription": "作为一名世界观架构师，请帮助我构建一个完整、自洽且富有魅力的小说世界。",
    "phaseTasks": [
      {
        "name": "worldBackgroundSetting",
        "shortName": "background",
        "label": "背景设定",
        "description": "请为我详细设定故事发生的时代、地理环境、社会结构、历史年表和关键的神话传说。",
        "description_en": "Please set in detail the era, geographical environment, social structure, historical timeline, and key myths and legends for the story.",
        "value": "world.background"
      },
      {
        "name": "worldRuleSystem",
        "shortName": "rules",
        "label": "规则系统",
        "description": "请为我设计这个世界运行的核心规则，例如独特的修炼体系、科技树、魔法定律或异能系统。",
        "description_en": "Please design the core rules that govern this world, such as unique cultivation systems, tech trees, magic laws, or supernatural power systems.",
        "value": "world.rules"
      },
      {
        "name": "worldFactionDistribution",
        "shortName": "factions",
        "label": "势力分布",
        "description": "请为我设计世界中的主要组织或势力，包括它们的构成、权力结构、地盘以及彼此间的关系。",
        "description_en": "Please design the main organizations or factions in the world, including their composition, power structure, territories, and relationships with each other.",
        "value": "world.factions"
      }
    ]
  },
  {
    "phaseKey": "roles",
    "phaseTitle": "核心角色塑造",
    "phaseDescription": "作为一名角色设计师，请帮助我塑造出形象丰满、有血有肉、令人印象深刻的角色。",
    "phaseTasks": [
      {
        "name": "roleCoreCharacter",
        "shortName": "main",
        "label": "主角与关键人物",
        "description": "请为我设计主角、主要反派和关键配角的详细档案，包括他们的身世、性格、动机、目标、能力和致命弱点。",
        "description_en": "Please design detailed profiles for the protagonist, main antagonist, and key supporting characters, including their background, personality, motivations, goals, abilities, and fatal flaws.",
        "value": "roles.main"
      },
      {
        "name": "roleRelationshipMap",
        "shortName": "relations",
        "label": "角色关系图谱",
        "description": "请为我构建一张角色关系网络图，清晰地展示角色之间的情感羁绊（如爱恨、师徒、敌友），并设定这些关系如何随情节发展而变化。",
        "description_en": "Please construct a character relationship network diagram that clearly shows the emotional bonds between characters (such as love/hate, master/disciple, friend/foe), and define how these relationships evolve with the plot.",
        "value": "roles.relations"
      },
      {
        "name": "roleGrowthArc",
        "shortName": "arc",
        "label": "角色成长弧光",
        "description": "请为核心角色设计一条清晰的成长或堕落轨迹（角色弧光），明确其在故事开端、中段和结尾时的关键转变。",
        "description_en": "Please design a clear growth or堕落 trajectory (character arc) for the core characters, defining their key transformations at the beginning, middle, and end of the story.",
        "value": "roles.arc"
      }
    ]
  },
  {
    "phaseKey": "plot",
    "phaseTitle": "故事情节架构",
    "phaseDescription": "作为一名金牌编剧，请帮助我设计出结构严谨、节奏得当、充满悬念和高潮的故事情节。",
    "phaseTasks": [
      {
        "name": "plotMainline",
        "shortName": "mainline",
        "label": "主线脉络",
        "description": "请为我确立贯穿全书的核心冲突和主角的终极目标，并设计出故事的开端、发展、高潮和结局（四幕式或三幕式结构）。",
        "description_en": "Please establish the core conflict throughout the book and the protagonist's ultimate goal, and design the story's beginning, development, climax, and ending (four-act or three-act structure).",
        "value": "plot.mainline"
      },
      {
        "name": "plotBranchline",
        "shortName": "branchlines",
        "label": "支线网络",
        "description": "请围绕主线，设计若干条用于丰富世界、塑造配角或深化主题的辅助情节线。",
        "description_en": "Please design several auxiliary plot lines around the main storyline to enrich the world, shape supporting characters, or deepen the theme.",
        "value": "plot.branchlines"
      },
      {
        "name": "plotForeshadowingAndReversal",
        "shortName": "twists",
        "label": "伏笔与反转",
        "description": "请为我设计几个关键的伏笔和意想不到的情节反转，并规划好它们在文中埋下和揭晓的最佳时机。",
        "description_en": "Please design several key foreshadowings and unexpected plot twists, and plan the optimal timing for their placement and revelation in the text.",
        "value": "plot.twists"
      }
    ]
  },
  {
    "phaseKey": "writing",
    "phaseTitle": "章节内容生成",
    "phaseDescription": "作为一名小说作家，请根据已有的设定和情节大纲，将故事转化为生动的文字。",
    "phaseTasks": [
      {
        "name": "writingChapterOutline",
        "shortName": "outline",
        "label": "分章大纲",
        "description": "请将情节大纲细化为每一章的具体内容规划，明确本章的核心事件、场景、出场人物和要达成的叙事目标。",
        "description_en": "Please refine the plot outline into specific content plans for each chapter, clarifying the core events, scenes, characters appearing, and narrative goals to be achieved in this chapter.",
        "value": "writing.outline"
      },
      {
        "name": "writingContentGeneration",
        "shortName": "generate",
        "label": "正文撰写",
        "description": "请根据分章大纲，撰写出包含生动场景描写、精彩人物对话和流畅叙事的章节正文初稿。",
        "description_en": "Please write the first draft of the chapter text based on the chapter outline, containing vivid scene descriptions, engaging character dialogues, and smooth narration.",
        "value": "writing.generate"
      },
      {
        "name": "writingStylePolish",
        "shortName": "polish",
        "label": "文风润色",
        "description": "请对已生成的初稿进行语言风格上的优化，使其更具文学性、画面感，或更符合特定的网文风格（如轻松、热血）。",
        "description_en": "Please optimize the language style of the generated first draft to make it more literary, visually evocative, or more in line with specific web novel styles (such as lighthearted, passionate).",
        "value": "writing.polish"
      }
    ]
  },
  {
    "phaseKey": "review",
    "phaseTitle": "审阅与优化",
    "phaseDescription": "作为一名资深文学编辑，请对已完成的稿件进行全面的诊断，并提出专业的优化建议。",
    "phaseTasks": [
      {
        "name": "reviewConsistencyCheck",
        "shortName": "consistency",
        "label": "一致性检查",
        "description": "请自动检查稿件，找出其中可能存在的设定矛盾、人物性格不一（OOC）、情节逻辑漏洞等问题。",
        "description_en": "Please automatically check the manuscript to identify potential setting contradictions, out-of-character (OOC) behavior, plot logic loopholes, and other issues.",
        "value": "review.consistency"
      },
      {
        "name": "reviewRhythmAnalysis",
        "shortName": "rhythm",
        "label": "节奏分析",
        "description": "请分析故事的叙事节奏，评估当前章节的冲突密度、信息量和悬念设置是否得当，并提出调整建议。",
        "description_en": "Please analyze the narrative pace of the story, evaluate whether the conflict density, information volume, and suspense setup in the current chapter are appropriate, and provide adjustment suggestions.",
        "value": "review.rhythm"
      },
      {
        "name": "reviewFeedbackIntegration",
        "shortName": "feedback",
        "label": "读者反馈整合",
        "description": "请分析读者的评论和反馈，提炼出共性的意见和建议，并将其转化为可执行的修改方向。",
        "description_en": "Please analyze readers' comments and feedback, extract common opinions and suggestions, and transform them into actionable revision directions.",
        "value": "review.feedback"
      }
    ]
  }
];

export {
  system,
  guidance,
  tutor,
  researcher,
  producer,
  validator,
  novel
}





















// 领航员、指挥官
/*
// 咨询顾问
const guidance = [
  {
    "phaseKey": "interaction_guidance",
    //"shortKey": "guidance",
    "phaseTitle": "交互引导",
    "phaseDescription": "通过多轮、有状态的对话，主动引导用户厘清模糊需求、完成复杂决策或操作流程。核心是AI的对话管理和引导能力。",
    "phaseTasks": [
      {
        "name": "aiContextInitiation",
        "shortName": "initiation",
        "label": "明确上下文意向目标",
        "description": "AI主动询问，了解用户的基本情况、核心诉求和想要达成的终极目标，建立对话的初始上下文。",
        "value": "guidance.initiation"
      },
      {
        "name": "aiMultiTurnDialogue",
        "shortName": "dialogue",
        "label": "深入挖掘与范围约束",
        "description": "通过连续、深入的提问，逐步挖掘用户未明说的深层需求、偏好和约束条件，动态完善用户画像和问题定义。",
        "value": "guidance.dialogue"
      },
      {
        "name": "aiStructuredGuidance",
        "shortName": "structured",
        "label": "结构化执行引导",
        "description": "根据上下文将模糊需求转化为清晰、可执行的任务列表，并引导用户一步一步完成每个子任务，或在获得用户授权后自动调用其他AI工作流来执行。",
        "value": "guidance.structured"
      }
    ]
  }
]

// 研究员
const researcher = [{
    "phaseKey": "research",
    "phaseTitle": "研究与分析",
    "phaseDescription": "从海量无序信息中提取、加工、整合成有意义的、可行动的洞察。核心是AI的信息处理与合成能力。",
    "phaseTasks": [
      {
        "name": "aiInformationCollection",
        "shortName": "collection",
        "label": "信息收集",
        "description": "根据研究主题，自动检索、抓取并初步过滤相关的文本、数据、文献等信息。",
        "value": "research.collection"
      },
      {
        "name": "aiAnalysisSynthesis",
        "shortName": "analysis",
        "label": "分析梳理",
        "description": "对收集的信息进行摘要、总结、分类、聚类、情感分析、数据提取等深度加工。",
        "value": "research.analysis"
      },
      {
        "name": "aiInsightSynthesis",
        "shortName": "synthesis",
        "label": "洞察合成",
        "description": "基于分析结果，识别模式、趋势和关联，生成结构化的结论、报告或决策建议。",
        "value": "research.synthesis"
      }
    ]
  }
]

// 生产者，创作者
const producer = [
  {
    "phaseKey": "creation",
    "phaseTitle": "创意与生成",
    "phaseDescription": "从0到1或从模糊到具体，产生全新的、原创性的内容。核心是AI的生成与构思能力。",
    "phaseTasks": [
      {
        "name": "aiBrainstorming",
        "shortName": "ideation",
        "label": "创意辅助",
        "description": "基于初始指令或种子概念，由AI生成多个创意方向、主题或初步概念草图。",
        "value": "creation.ideation"
      },
      {
        "name": "aiContentGeneration",
        "shortName": "generation",
        "label": "内容生成",
        "description": "根据选定方向和详细提示词，生成完整的初稿内容（文本、图像、代码等）。",
        "value": "creation.generation"
      },
      {
        "name": "aiVariationExpansion",
        "shortName": "variation",
        "label": "扩展优化",
        "description": "对生成内容进行不同风格、语气、格式的转换，或进行扩写、缩写、翻译等。",
        "value": "creation.variation"
      }
    ]
  }
]

 // 质检员
const validator = [
  {
    "phaseKey": "optimization",
    "phaseTitle": "优化与校验",
    "phaseDescription": "对已有内容进行批判性检查、修正、提升，使其更符合目标与规范。核心是AI的校验与评估能力。",
    "phaseTasks": [
      {
        "name": "aiValidationCheck",
        "shortName": "validation",
        "label": "审核校验",
        "description": "自动检查内容的语法、逻辑、事实准确性、风格一致性、代码错误、合规性等问题。",
        "value": "optimization.validation"
      },
      {
        "name": "aiFeedbackAnalysis",
        "shortName": "feedback",
        "label": "反馈分析",
        "description": "分析内外部（如用户）对内容的反馈，总结主要评价、情绪和修改点。",
        "value": "optimization.feedback"
      },
      {
        "name": "aiOptimizationIteration",
        "shortName": "optimization",
        "label": "优化迭代",
        "description": "根据校验和反馈结果，自动或辅助生成内容的优化版本、修改建议和替代方案。",
        "value": "optimization.optimization"
      }
    ]
  }
] 

// 学习导师
 const tutor =  [
  {
    "phaseKey": "learning_navigation",
    //"shortKey": "learning",
    "phaseTitle": "认知定位规划",
    "phaseDescription": "AI帮助学习者评估现状、明确目标，并制定高度个性化的学习路径与资源规划。",
    "phaseTasks": [
      {
        "name": "aiLearningAssessment",
        "shortName": "assessment",
        "label": "学习导航与评估",
        "description": "通过对话或测试，AI评估学习者当前的知识水平、学习风格和兴趣点，明确“从哪里开始”。",
        "value": "learning.assessment"
      },
      {
        "name": "aiPathGeneration",
        "shortName": "pathing",
        "label": "个性化学习路径",
        "description": "根据评估结果和学习目标，AI生成一份阶段化的学习计划，包括推荐资源、关键概念和学习节奏。",
        "value": "learning.pathing"
      }
    ]
  },
  {
    "phaseKey": "knowledge_input",
    //"shortKey": "knowledge",
    "phaseTitle": "多模态理解",
    "phaseDescription": "AI作为超级导师，提供最适合学习者的解释、材料和案例，以促进最初的理解。",
    "phaseTasks": [
      {
        "name": "aiKnowledgeProvision",
        "shortName": "provision",
        "label": "知识解读",
        "description": "AI根据学习路径，提供核心概念的多种解释（类比、比喻、严格定义），并推荐高质量的学习材料。",
        "value": "knowledge.provision"
      },
      {
        "name": "aiConceptVisualization",
        "shortName": "visualization",
        "label": "概念可视化",
        "description": "AI将抽象概念生成图像、思维导图、流程图。",
        "value": "knowledge.visualization"
      },
      {
        "name": "aiConceptExample",
        "shortName": "example",
        "label": "案例分析",
        "description": "结合真实世界的案例进行讲解，促进理解。",
        "value": "knowledge.example"
      }
    ]
  },
  {
    "phaseKey": "knowledge_processing",
    //"shortKey": "knowledge_pro",
    "phaseTitle": "知识系统化",
    "phaseDescription": "AI引导学习者对知识进行深加工，将其从碎片化信息转化为结构化的个人知识体系。",
    "phaseTasks": [
      {
        "name": "aiGuidedSummarization",
        "shortName": "summarization",
        "label": "知识提炼",
        "description": "AI通过提问、给模板等方式，引导学习者用自己的话做笔记、写摘要、提问题，对抗“一看就会，一放就忘”。",
        "value": "knowledge_pro.summarization"
      },
      {
        "name": "aiKnowledgeMapping",
        "shortName": "mapping",
        "label": "构建知识图谱",
        "description": "AI自动或辅助将新学的概念与已知概念连接起来，形成一张可视化的知识网络图，明确知识间的关联。",
        "value": "knowledge_pro.mapping"
      }
    ]
  },
  {
    "phaseKey": "application_validation",
    //"shortKey": "application",
    "phaseTitle": "实践验证纠偏",
    "phaseDescription": "AI创建实践环境，测试学习者的掌握程度，并提供即时、精准的反馈，纠正理解偏差。",
    "phaseTasks": [
      {
        "name": "aiScenarioGeneration",
        "shortName": "scenario",
        "label": "生成实践情景",
        "description": "AI生成练习题、模拟考试、项目任务、辩论话题等，让学习者在不同情境中应用所学知识。",
        "value": "application_validation.scenario"
      },
      {
        "name": "aiFeedbackCorrection",
        "shortName": "feedback",
        "label": "模拟评审反馈",
        "description": "AI对学习者的答案、解决方案进行评审，指出错误、逻辑漏洞，并提供解析和改进建议。",
        "value": "application_validation.feedback"
      }
    ]
  },
  {
    "phaseKey": "reinforcement_teaching",
    "phaseTitle": "复习强化",
    "phaseDescription": "AI基于遗忘曲线安排复习，并通过“费曼学习法”确保知识的彻底内化和精通。",
    "phaseTasks": [
      {
        "name": "aiSpacedRepetition",
        "shortName": "repetition",
        "label": "间隔检查",
        "description": "AI根据遗忘规律，定期、主动地向学习者推送之前学过的概念问题进行检索练习，强化长期记忆。",
        "value": "reinforcement_teaching.repetition"
      },
      {
        "name": "aiFeynmanSimulation",
        "shortName": "teaching",
        "label": "听讲模拟",
        "description": "AI扮演一个“什么都不懂的学生”，要求学习者讲解某个概念。AI会提出问题挑战，直到讲解清晰为止。",
        "value": "reinforcement_teaching.teaching"
      }
    ]
  }
];

*/